module.exports = __webpack_public_path__ + "static/media/transgender.b9b085cb.svg";